import React from 'react';
import { Container } from 'react-bootstrap';
import './ReturnsPolicy.css';

const ReturnsPolicy = () => {
  return (
    <div className="returns-policy-page">
      <Container fluid className="returns-policy-container">
        <h1 className="returns-policy-title">Returns Policy</h1>

        <div className="returns-policy-card">
          <h2 className="returns-policy-card-heading">Our Returns & Refund Policy</h2>
          <div className="returns-policy-card-content">
            <p>
              <strong>1. Eligibility for Refund, Return or Exchange</strong><br />
              We offer refunds, returns, or exchanges only for damaged, defective, or incorrect products delivered to the customer.
            </p>
            <p>
              <strong>2. Reporting Timeframe</strong><br />
              All issues must be reported within 24 hours of receiving the order. Claims made after this timeframe cannot be accepted.
            </p>
            <p>
              <strong>3. Exchange Policy</strong><br />
              Exchanges are available under the following conditions: The product is incorrect, damaged, or defective; the customer informs us within 24 hours of delivery; the item is unused, unwashed, and returned with original packaging and tags. Size exchanges for correctly delivered products are not eligible, unless explicitly mentioned on the product page.
            </p>
            <p>
              <strong>4. Condition of Returned Items</strong><br />
              To qualify for a refund, return, or exchange, the product must be: Unused and unwashed; in original condition with all tags intact; packed securely to avoid transit damage.
            </p>
            <p>
              <strong>5. Return Courier Charges</strong><br />
              For returns initiated due to customer reasons (e.g., unwanted item, size issue, change of mind), the return courier charges must be borne by the customer. For returns due to damaged or incorrect products, courier charges will be handled by us.
            </p>
            <p>
              <strong>6. Verification Process</strong><br />
              Customers must share clear photos/videos of the issue when reporting a claim. Refunds or exchanges will be approved only after verification.
            </p>
            <p>
              <strong>7. Refund Method</strong><br />
              Refunds will be processed to the original payment method. Processing timelines may vary depending on your bank or payment provider.
            </p>
            <p>
              <strong>8. Non-Returnable Items</strong><br />
              Certain items may not be eligible for return or exchange due to hygiene or product-specific reasons. Such exceptions will be mentioned on product pages.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ReturnsPolicy;
